import { ViewModeType } from '@lumapps/designer-widget-settings/types';
import { viewModeHorizontal, viewModeVertical } from '@lumapps/lumx/custom-icons';
import { mdiPlay } from '@lumapps/lumx/icons';
import { Orientation } from '@lumapps/lumx/react';

import { WIDGET_PLAY } from './keys';
import { WidgetPlayPropertiesType } from './types';

export const WIDGET_PLAY_TYPE = 'play';
export const WIDGET_PLAY_ICON = mdiPlay;
export const WIDGET_PLAY_EDITION_SCOPE = 'editable-widget-play';

export const DEFAULT_ORIENTATION: WidgetPlayPropertiesType['orientation'] = Orientation.horizontal;

export const ORIENTATION_VARIANTS: ViewModeType<WidgetPlayPropertiesType['orientation']>[] = [
    {
        label: WIDGET_PLAY.HORIZONTAL,
        value: Orientation.horizontal,
        icon: viewModeHorizontal,
    },
    {
        label: WIDGET_PLAY.VERTICAL,
        value: Orientation.vertical,
        icon: viewModeVertical,
    },
];
